import { graphql } from 'src/gql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query staffingAgencyRemitDetailsById($id: MongoID!) {
    cat {
      distributionSubcategory{
        byId(_id: $id) {
          _id
          staffingAgency {
            remit {
              name
              address {
                street
                city
                state
                zip
              }
              paymentDetails
              paymentTerms
            } 
          }
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type StaffingAgencyRemitDetailsById = NonNullable<NonNullable<NonNullable<NonNullable<TData>['cat']>['distributionSubcategory']>['byId']>

const useStaffingAgencyRemitDetailsById = (id: string): StaffingAgencyRemitDetailsById | undefined => {
  const { data } = useGraphQL(document, { id }, {
    enabled: typeof id === 'string'
  })
  const distribution = data?.cat?.distributionSubcategory?.byId ?? undefined
  return distribution
}

export { useStaffingAgencyRemitDetailsById, document as staffingAgencyRemitDetailsByIdDocument }
